export default __webpack_public_path__ + "static/media/rabbit_sad_2.18653943.svg";